module.exports = __webpack_public_path__ + "img/arrowDirectionLeft.bb9434b3.svg";